





import { Vue, Component } from 'vue-property-decorator';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import EventBus, { Event } from '@/event.bus';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';

@Component

export default class Configuration extends Vue {
  businessUnitId: string = '';

  created() {
    const { currentBusinessUnit } = UserBusinessUnitService;

    this.businessUnitId = currentBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Configuration')) {
        this.businessUnitId = businessUnit.id;
      }
    });
  }
}

